import { defineColumns } from '@juvare/platform-shared/features/storage';
export const fileColumns = defineColumns({
    directory: {
        type: 'boolean-required',
        index: true,
    },
    name: {
        type: 'string-required',
        index: 'partial',
    },
    type: {
        type: 'string-required',
    },
    ownerId: {
        type: 'string-required',
        index: false,
    },
    ownerDisplayName: {
        type: 'string',
        index: 'partial',
    },
    checkOutUserId: {
        type: 'id',
        index: true,
    },
    checkOutUserDisplayName: {
        type: 'string',
    },
    permissions: {
        type: 'string',
        index: false,
    },
    currentVersionId: {
        type: 'id',
    },
    path: {
        type: 'string',
        caseSensitive: true,
    },
    summary: {
        type: 'string',
    },
    watchersList: {
        type: 'string-array-required',
    },
    archived: {
        type: 'boolean-required',
    },
    archiveDate: {
        type: 'number',
    },
    public: {
        type: 'boolean',
    },
    readAccountIds: {
        type: 'string-array',
    },
    modifyAccountIds: {
        type: 'string-array',
    },
    readOrgIds: {
        type: 'string-array',
    },
    modifyOrgIds: {
        type: 'string-array',
    },
    readSystemRoles: {
        type: 'string-array',
    },
    modifySystemRoles: {
        type: 'string-array',
    },
    hidden: {
        type: 'boolean-required',
        index: true,
    },
    contentLength: {
        type: 'number',
    },
});
